/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  GET_SCOPES,
  FETCH_SCOPES_SUCCESS,
  FETCH_SCOPES_FAILURE,
  ADDED_SCOPES,
  DELETE_SCOPES,
  UPDATE_SCOPES,
} from './actionTypes'
import { isEqual } from '../../../utils/lodash-utils'


const scopes = (
  state = {
    didInvalidate: false,
    isFetching: false,
    items: [],
  },
  action,
) => {
  switch (action.type) {
    case GET_SCOPES:
      return Object.assign({}, state, {
    	    isFetching: true,
      	    didInvalidate: false,
     })
    case FETCH_SCOPES_SUCCESS:
        const items = action.scopes
        const updatedState = Object.assign({}, state, {
          isFetching: false,
          didInvalidate: false,
          items: items
        })
        return isEqual(updatedState, state) ? state : updatedState
      case FETCH_SCOPES_FAILURE:
        return Object.assign({}, state, {
          isFetching: false,
          didInvalidate: true,
          errorMessage: action.errorMessage,
          items: []
        })
     case DELETE_SCOPES:
    	const deletedCred = action.deletedScopes
    	let filteredList=[];
            filteredList=state.items.filter(item => {
                return item.id !== deletedCred
            })
        const updatedItem =  Object.assign({}, state, {
          isFetching: false,
          didInvalidate: false,
          items: filteredList
        })
        return isEqual(updatedItem, state) ? state : updatedItem
    case UPDATE_SCOPES:
	const updatedCred = action.updatedScopes
    	let updatedCatalog = state.items
    	for (let i = 0; i < updatedCatalog.length ; i++){
            if(updatedCred.id === updatedCatalog[i].id){
                updatedCatalog[i]=updatedCred;
                break;
            }
        }
        const updatedCatalogItem =  Object.assign({}, state, {
          isFetching: false,
          didInvalidate: false,
          items: updatedCatalog
        })
        return isEqual(updatedCatalogItem, state) ? state : updatedCatalogItem
    case ADDED_SCOPES:
	const addedCred = action.addedScopes
    	let addedCatalog = state.items
    	let isNewCredential=true
        for (let i = 0; i < addedCatalog.length ; i++){
            if(addedCred.id === addedCatalog[i].id){
               	isNewCredential=false
				break;
            }
        }
        if(isNewCredential){
        	addedCatalog.push(addedCred);
		}
        const addCatalogItem =  Object.assign({}, state, {
          isFetching: false,
          didInvalidate: false,
          items: addedCatalog
        })
        return isEqual(addCatalogItem, state) ? state : addCatalogItem
     default:
      return state
  }
}

export default scopes
